import { render } from "./AppHeader.vue?vue&type=template&id=7344b108&scoped=true&bindings={\"title\":\"props\",\"assc\":\"data\",\"isTitleVisible\":\"options\"}"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=7344b108&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7344b108"

export default script